import { render, staticRenderFns } from "./FragmentOgEmbed.vue?vue&type=template&id=fa1c8da0&scoped=true"
import script from "./FragmentOgEmbed.vue?vue&type=script&lang=ts"
export * from "./FragmentOgEmbed.vue?vue&type=script&lang=ts"
import style0 from "./FragmentOgEmbed.vue?vue&type=style&index=0&id=fa1c8da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1c8da0",
  null
  
)

export default component.exports